module.exports = __webpack_public_path__ + "static/img/point_qd_ssas.10e3abba.png";